import React, { useState } from "react";
import "./GamesGrid.css";

const games = [
  { title: "Super Tiger", img: require('../../images/1.png') },
  { title: "Baccarat Classic", img: require('../../images/1.png') },
  { title: "Money Time", img: require('../../images/1.png')},
  { title: "7 Up Down", img: require('../../images/1.png')},
  { title: "Money Wheel", img: require('../../images/1.png') },
  { title: "Fortune Gems", img: require('../../images/1.png')},
];

export default function GamesGrid() {
  const [active, setActive] = useState("exclusive");

  return (
    <div className="exclusive-wrapper">
    
      {/* Games */}
      <div className="games-grid-cas">
        {games.map((game, index) => (
          <div className="game-card" key={index}>
            <img src={game.img} alt={game.title} />
          </div>
        ))}
      </div>

      {/* More Button */}
      <button className="more-btn">More</button>
    </div>
  );
}
